import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withConsumer } from '../util/constants';

class ActionLinkBase extends React.Component {
  componentDidMount() {
    this.link.addEventListener('mouseup', this.logHandler);
    this.link.addEventListener('click', this.clickHandler);
  }

  componentWillUnmount() {
    this.link.removeEventListener('mouseup', this.logHandler);
    this.link.removeEventListener('click', this.clickHandler);
  }

  logHandler = (e) => {
    const {
      text,
      href,
      extraAttrs,
      logger,
      logContent,
      content,
      scenarioName,
      extraClassNames,
      id,
    } = this.props;
    if (href === '#') {
      e.preventDefault();
    }

    // special handling the logging of "learn more" help for click event blocked by the apex stopImmediatePropagation
    if (scenarioName) {
      logger.trace(scenarioName, logContent(`id=${id}, text=${text}, href=${href}, extraAttrs=${JSON.stringify(extraAttrs)}, content=${content}, extraClassNames=${JSON.stringify(extraClassNames)}`));
      this.loggedInsideLogHandler = true; // use another flag to check if we do log
    }
  };

  clickHandler = (e) => {
    const {
      text,
      href,
      action,
      extraAttrs,
      logger,
      logContent,
      content,
      scenarioName,
      actionCallback,
      callbackType,
      extraClassNames,
      id,
    } = this.props;
    if (href === '#') {
      e.preventDefault();
    }

    action(e);
    actionCallback(callbackType, id);
    if (scenarioName && (this.loggedInsideLogHandler !== true)) {
      // learn more help will not get here actually because of the stopImmediatePropagation of Apex clickHandler
      // special handling the logging of "learn more" help
      logger.trace(scenarioName, logContent(`id=${id}, text=${text}, href=${href}, extraAttrs=${JSON.stringify(extraAttrs)}, content=${content}, extraClassNames=${JSON.stringify(extraClassNames)}`));
    }
  };

  render() {
    const {
      text,
      ariaLabel,
      href,
      extraClassNames,
      extraAttrs,
      isJumpOut,
    } = this.props;

    return (
      <a
        href={href}
        className={classNames('btn btn-link action-link', extraClassNames)}
        aria-label={ariaLabel || text}
        role={href === '#' ? 'button' : 'link'}
        target={isJumpOut ? '_blank' : undefined}
        rel="noopener noreferrer"
        {...extraAttrs}
        ref={(element) => { this.link = element; }}
      >
        {text}
      </a>
    );
  }
}

ActionLinkBase.propTypes = {
  text: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  action: PropTypes.func,
  extraClassNames: PropTypes.arrayOf(PropTypes.string),
  extraAttrs: PropTypes.objectOf(PropTypes.string),
  content: PropTypes.string,
  scenarioName: PropTypes.string,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
  actionCallback: PropTypes.func,
  callbackType: PropTypes.string,
  isJumpOut: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

ActionLinkBase.defaultProps = {
  ariaLabel: '',
  href: '#',
  action: _.noop,
  extraClassNames: [],
  extraAttrs: {},
  content: '',
  scenarioName: undefined,
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
  actionCallback: _.noop,
  callbackType: '',
  isJumpOut: false,
  i18n: {
    getString: _.noop,
  },
  id: '',
};

export const ActionLink = withConsumer(ActionLinkBase);
